import styled from "@emotion/styled";

import { RelativeSizeIcon } from "../MetadataInfo.styled";

export const TableIcon = styled(RelativeSizeIcon)`
  transform: translateY(-1px);
`;
